"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XMLFeed = void 0;
var _meteora = require("meteora");
var _classEvents = require("../extensions/class-events.js");
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/* ----------------------------------------------------------------
XML Feed
---------------------------------------------------------------- */
var XMLFeed = /*#__PURE__*/function (_ClassEvents) {
  _inherits(XMLFeed, _ClassEvents);
  var _super = _createSuper(XMLFeed);
  function XMLFeed() {
    var _this;
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    _classCallCheck(this, XMLFeed);

    // Inherit the class event listeners
    _this = _super.call(this); // This will be used for out URL creation

    _this.api = {}; // Where we will store the filter parameters

    _this.value = {}; // The url used for ajax calls

    _this.url = url || ''; // ObjectAssign all the user's options

    for (var key in _this.settings) {
      // Just check if the key exists in the user's options and if it does override the defaults
      if (_this.settings.hasOwnProperty(key) && options.hasOwnProperty(key)) _this.settings[key] = options[key];
    }
    return _this;
  }
  _createClass(XMLFeed, [{
    key: "change",
    value: function change() {
      // Call the change callback
      this.callback('change', this.value);
    } // Method to set paramters in the value object
  }, {
    key: "set",
    value: function set() {
      var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (typeof parameter === 'string' || typeof parameter === 'number') {
        // Reset the value of the parameter
        this.value[parameter] = [];
        this.add(parameter, value);
      } else {
        for (var key in parameter) {
          if (parameter.hasOwnProperty(key)) this.set(key, parameter[key]);
        }
      } // Call the change method

      this.change(); // Call the set callback

      this.callback('set', this.value);
    } // Method to add parameters and values to the values object
  }, {
    key: "add",
    value: function add() {
      var _this2 = this;
      var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (typeof parameter === 'string' || typeof parameter === 'number') {
        // If we dont have this parameter yet, create it as an array
        if (this.value[parameter] == undefined) this.value[parameter] = [];
        if (Array.isArray(value)) {
          value.forEach(function (value) {
            // If the filter parameter value does not contain this value, then add it
            if (_this2.value[parameter].indexOf(value) == -1) _this2.value[parameter].push(value);
          });
        } else {
          // If the parameter value is not an array
          // Simply push the value to the filter
          if (this.value[parameter].indexOf(value) == -1) this.value[parameter].push(value);
        }
      } else {
        for (var key in parameter) {
          if (parameter.hasOwnProperty(key)) this.add(key, parameter[key]);
        }
      } // Call the change method

      this.change(); // Call the add callback

      this.callback('add', this.value);
    } // Method to remove parameters and values from the values object
  }, {
    key: "remove",
    value: function remove() {
      var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (typeof parameter === 'string' || typeof parameter === 'number') {
        if (this.value[parameter] && Array.isArray(value)) {
          for (var index = 0; index < value.length; index++) {
            console.log(value[index]);
            this.remove(parameter, value[index]);
          }
        } else if (this.value[parameter] && this.value[parameter].indexOf(value) >= 0) {
          // Remove this value from the parameter array
          this.value[parameter].splice(this.value[parameter].indexOf(value), 1); // If the parameter array is empty, delete it

          if (this.value[parameter].length === 0) delete this.value[parameter];
        } else if (this.value[parameter]) {
          // Remove the parameter
          delete this.value[parameter];
        }
      } else if (Array.isArray(parameter)) {
        for (var _index = 0; _index < parameter.length; _index++) {
          delete this.value[parameter[_index]];
        }
      } else {
        try {
          for (var key in parameter) {
            if (parameter.hasOwnProperty(key)) this.remove(key, parameter[key]);
          }
        } catch (err) {
          console.log(err);
        }
      } // Call the change method

      this.change(); // Call the remove callback

      this.callback('remove', this.value);
    } // Method to remove all parameters and values from the values object
  }, {
    key: "clear",
    value: function clear() {
      // Clear all filters
      this.value = {}; // Call the change method

      this.change(); // Call the clear callback

      this.callback('clear', this.value);
    }
  }, {
    key: "filter",
    value: function filter() {
      var _this3 = this;

      // Used to begin the URL parameters
      this.api.prefix = '?'; // Used to save our default api URL

      this.api.url = this.url; // Used to determine if our prefix should be ? || &

      this.api.index = this.url.indexOf('?') >= 0 ? 1 : 0; // This will be a more pretty URL for frontend purposes

      this.api.segmentURL = window.location.origin + window.location.pathname; // Generate the URL based on the current filters

      for (var key in this.value) {
        if (this.value.hasOwnProperty(key)) {
          // Determine which prefix to use
          this.api.prefix = this.api.index === 0 ? '?' : '&'; // If we have a value for a given parameter

          if (this.value[key].length) {
            // Create an api URL
            this.api.url += "".concat(this.api.prefix + key, "=").concat(this.value[key].join(',')); // Create a prettier URL

            this.api.segmentURL += "".concat(this.api.prefix + key, "=").concat(this.value[key].join(',')); // Add 1 to our index

            this.api.index += 1;
          }
          ;
        }
        ;
      }
      (0, _meteora.ajax)({
        url: this.api.url,
        method: 'GET',
        error: function error(response) {
          return console.warn(response);
        },
        success: function success(response) {
          // Call the change method
          _this3.change(); // Call the filter callback

          _this3.callback('filter', response);
        }
      });
    }
  }]);
  return XMLFeed;
}(_classEvents.ClassEvents);
exports.XMLFeed = XMLFeed;